import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DialogContentModal from "../DialogContent";
import { Col, Container, Row } from "react-bootstrap";
import SearchSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/map-submission/Summary/SearchSummary";
import MapSubmissionSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/map-submission/Summary/MapSubmissionSummary";
import SelfApprovalSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/self-approval/Summary/SelfApprovalSummary";
import ResidentialSelfSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/resedential-self/MapSubmissionSummary";
import TakeActionItem from "../../../Forms/TakeActionItem";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { set } from "lodash";

const PrimaryContent = ({ formData, handleChange, serviceName, daLogo, avpLogo, requestLetterId = null }) => {
  const [smShow, setSmShow] = useState(false);
  const [modalType, setModalType] = useState("");
  const [iframeSrc, setIframeSrc] = useState("");
  
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const handleDocView = async (fileStoreId) => {
    const url = await getDocumentByFileStoreId(fileStoreId, setLoading, true);
    setSmShow(true);
    console.log("handleCHangeisTriggered", fileStoreId, typeof url, url);
    setIframeSrc(url);
    setModalType("DOCUMENT");
  };

  const handleApprovalLetterView = () => {
    const pdfUrl =  formData?.approvalLetterUrl || formData?.additionalDetails?.approvalLetterUrl  
    window.open(pdfUrl, "_blank");
  if (!formData?.approvalCertificateUrl) return;
  setIframeSrc(formData?.approvalLetterUrl || formData?.additionalDetails?.approvalLetterUrl);
  setModalType("APPROVAL_LETTER");
  
};

  return (
    <section className="groupContainer2">
      <div className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">{t("Take Actions")}</h2>
        </div>
        <Container fluid className="formInputContainer">
          <Row>
            <Col>
              <h5 style={{ fontWeight: "bold" }}>{t(`BPA_APPLICATION_NUMBER_LABEL`)}</h5>
            </Col>

            <Col>
              <p>{formData?.applicationNo || ""}</p>
            </Col>
            <Col>
              <h5 style={{ fontWeight: "bold" }}>Mobile Number</h5>
            </Col>

            <Col>
              <p>{formData?.landInfo?.owners?.[0]?.mobileNumber || ""}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <h5 style={{ fontWeight: "bold" }}>Applicant Name</h5>
            </Col>

            <Col>
              <p>{formData?.landInfo?.owners?.[0]?.name || ""}</p>
            </Col>
            <Col>
              <h5 style={{ fontWeight: "bold" }}>Service Name</h5>
            </Col>

            <Col>
              <p>{serviceName}</p>
            </Col>
          </Row>
          <Row className="align-item-center">
           <Col md={3}>
  <h5 style={{ fontWeight: "bold" }}>{t("View Application")}</h5>
</Col>

<Col md={3}>
  {/* Existing Application View */}
  <button
    className="btn btn-primary"
    style={{
      padding: "4px 8px",
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff",
    }}
    onClick={() => {
      setIframeSrc(""); // reset iframe
      setSmShow(true);
      setModalType("APPLICATION");
    }}
  >
    View
  </button>


</Col>
 {(formData?.approvalLetterUrl || formData?.additionalDetails?.approvalLetterUrl) && <Col md={3}>
  <h5 style={{ fontWeight: "bold" }}>{t("Approval Letter")}</h5>
</Col>}

<Col md={3}>
  {/* NEW Approval Letter View */}
  {(formData?.approvalLetterUrl || formData?.additionalDetails?.approvalLetterUrl) ? (
    <button
      className="btn btn-secondary"
      style={{
        padding: "4px 8px",
        fontSize: "14px",
      }}
      onClick={handleApprovalLetterView}
    >
      View Approval Letter
    </button>
  )
  : (
    <Col></Col>
  )}
</Col>


            {requestLetterId ? (
              <React.Fragment>
                <Col>View Request Letter</Col>
                <Col>
                  {" "}
                  <button
                    className="btn btn-primary"
                    style={{
                      padding: "4px 8px",
                      fontSize: "14px",
                      margin: "4px 0px 8px 0px",
                      backgroundColor: "rgba(52, 73, 94, 0.94)",
                      color: "#fff",
                    }}
                    onClick={() => handleDocView(requestLetterId)}
                  >
                    View
                  </button>
                </Col>
              </React.Fragment>
            ) : (
              <Col></Col>
            )}
          </Row>
        </Container>
      </div>
{modalType === "APPLICATION" && (
  <DialogContentModal
    title="Application Details"
    dataOpen
    onClose={() => setModalType(null)}
  >
    {formData?.planOn === "SELF_MAP" ? (
      <ResidentialSelfSummary formData={formData} logoData={formData?.department === "DA" ? daLogo : avpLogo} />
    ) : formData?.applicationType === "FORM_MAP" ? (
      // MapSubmissionSummary already handles self-approval planOn types internally (isSelfCert),
      // so it is comprehensive for all FORM_MAP applications including self-approval files.
      <MapSubmissionSummary formData={formData} logoData={formData?.department === "DA" ? daLogo : avpLogo} />
    ) : (formData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
      formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") ? (
      <SelfApprovalSummary formData={formData} />
    ) : (formData?.applicationType === "FORM_LANDUSE" || formData?.applicationType === "FORM_PRESSRELEASE") ? (
      <TakeActionItem
        formType={formData?.applicationType === "FORM_LANDUSE" ? "formLandUse" : "FORM_PRESSRELEASE"}
        id={formData?.applicationNo}
        logoData={formData?.department === "DA" ? daLogo : avpLogo}
      />
    ) : null}
  </DialogContentModal>
)}

{modalType === "PDF" && iframeSrc && (
  <DialogContentModal
    title="Document Viewer"
    dataOpen
    onClose={() => setModalType(null)}
  >
    <div className="iframe-container">
      <iframe
        className="fastPas-iframe"
        src={iframeSrc}
        title="PDF Viewer"
      />
    </div>
  </DialogContentModal>
)}
{ modalType === "APPROVAL_LETTER" && (
      <iframe
        src={iframeSrc}
        title="PDF Viewer"
      />
)}


    </section>
  );
};

export default PrimaryContent;
